import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue/src/components/modal';
import { Trade } from 'ah-api-gateways';
import PaymentTradeDetails from '../PaymentTradeDetails.vue';
import { reactive, ref } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhPaymentState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsTradeDetailsModal',
  props: {
  tradeId: {
    type: String,
    required: true,
    default: () => '',
  },
  tradeComposedReferenceNumber: {
    type: String,
    required: true,
    default: () => '',
  },
},
  setup(__props) {

const props = __props;


const paymentState = useAhPaymentState();
const requestManager = useRequestManager().manager;
const paymentsTradeDetailsModal = ref<InstanceType<typeof BModal> | null>(null);

const state = reactive({
  trade: null as Trade | null,
});

function show() {
  if (props.tradeId) {
    requestManager
      .sameOrCancelAndNew('getAdminTrade', paymentState.services.trade.getTrade(props.tradeId))
      .subscribe((r) => (state.trade = r));
  }
  paymentsTradeDetailsModal.value?.show();
}

function hide() {
  state.trade = null;
  paymentsTradeDetailsModal.value?.hide();
}

return { __sfc: true,props, paymentState, requestManager, paymentsTradeDetailsModal, state, show, hide, BModal, PaymentTradeDetails }
}

})